/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * BrandingSection — Accordion 6: page title, subtitle, accent colour, record count toggle.
 * Page Title defaults to table display name; Subtitle defaults to table description.
 * Accent Colour offers predefined Arcee theme swatches.
 */

import React from 'react';

export default function BrandingSection({ config, updateConfig, theme, tableDisplayName, tableDescription }) {
  const branding = config.branding || {};

  function update(key, value) {
    updateConfig({ branding: { ...branding, [key]: value } });
  }

  return (
    <div className="d-flex flex-column gap-3">

      {/* Page Title */}
      <div>
        <label className="form-label small fw-semibold">
          Page Title
          {tableDisplayName && branding.page_title === tableDisplayName && (
            <span className="ms-2 badge bg-light text-muted border" style={{ fontSize: '0.68rem', fontWeight: 400 }}>
              from table name
            </span>
          )}
        </label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={branding.page_title || ''}
          onChange={e => update('page_title', e.target.value)}
          placeholder={tableDisplayName || 'My Public Page'}
          maxLength={120}
        />
      </div>

      {/* Subtitle */}
      <div>
        <label className="form-label small fw-semibold">
          Subtitle
          {tableDescription && branding.subtitle === tableDescription && (
            <span className="ms-2 badge bg-light text-muted border" style={{ fontSize: '0.68rem', fontWeight: 400 }}>
              from table description
            </span>
          )}
        </label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={branding.subtitle || ''}
          onChange={e => update('subtitle', e.target.value)}
          placeholder={tableDescription || 'A short description for visitors'}
          maxLength={250}
        />
      </div>

      {/* Show record count toggle */}
      <div className="form-check form-switch">
        <input
          type="checkbox"
          className="form-check-input"
          id="show-record-count"
          checked={branding.show_record_count !== false}
          onChange={e => update('show_record_count', e.target.checked)}
        />
        <label className="form-check-label small" htmlFor="show-record-count">
          Show record count in header
        </label>
      </div>

      {/* Live branding preview */}
      {branding.page_title && (
        <div
          className="p-3 rounded border"
          style={{
            borderColor: theme.primary,
            borderLeftWidth: 4,
            background: '#f8fafc',
          }}
        >
          <div
            className="fw-bold"
            style={{ color: theme.primary, fontSize: 16 }}
          >
            {branding.page_title || 'Page Title'}
          </div>
          {branding.subtitle && (
            <div className="text-muted small mt-1">{branding.subtitle}</div>
          )}
        </div>
      )}
    </div>
  );
}
